"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const design_system_1 = require("@zapier/design-system");
const common_components_1 = require("@zapier/common-components");
const common_utils_1 = require("@zapier/common-utils");
const buttonCss = {
    border: `2px solid ${design_system_1.Colors.transparent}`,
    borderRadius: '4px',
    color: design_system_1.Colors.grey700,
    padding: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    ':hover': {
        cursor: 'pointer',
    },
    ':first-of-type': {
        marginRight: '2px',
    },
};
const getStepMenuButtonCss = ({ isActive, isFocused, }) => (Object.assign(Object.assign(Object.assign({}, buttonCss), (isActive && !isFocused
    ? {
        background: design_system_1.Colors.grey100,
    }
    : {})), (isFocused
    ? {
        border: `2px solid ${design_system_1.Colors.blue500}`,
    }
    : {})));
const StepMenuButton = ({ ariaLabel, buttonRef, iconName, isActive, onClick, onKeyDown, }) => {
    const [isFocused, setFocused] = react_1.useState(false);
    return (common_utils_1.isolateComponent("button", { "aria-label": ariaLabel, css: getStepMenuButtonCss({
            isActive,
            isFocused,
        }), onBlur: () => {
            setFocused(false);
        }, onClick: onClick, onFocus: () => {
            setFocused(true);
        }, onKeyDown: onKeyDown, ref: buttonRef },
        common_utils_1.isolateComponent(common_components_1.Icon, { name: iconName, size: 13 })));
};
const FastStepMenuButton = react_1.memo(StepMenuButton);
exports.default = FastStepMenuButton;
